const { makeStyles } = require("@material-ui/core");

export const vehiclePageStyles = makeStyles((theme) => ({
    flaggedRow: {
        position: 'realtive',
        "&::before": {
            content: "''",
            position: "absolute",
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        },
    },
    flaggedRowAsset: {
        "&::before": {
            background: '#ffff0029',
        },
    },
    flaggedRowActivity: {
        "&::before": {
            background: '#ff940033',
        },
    },
    flaggedRowTransport: {
        "&::before": {
            background: '#ff940033',
        },
    },
    pendingClientApprovalRow: {
        "&::before": {
            background: '#fcc35433',
        },
    },
    table: {
        flex: 1
    },
    withMarginTop:{
        marginTop:'1rem'
    },
    spinner: {
        position: 'absolute',
        top: '50%',
        left: 'calc(50% + 100px)',
        zIndex: '100'
    },
    icon: {
        fill: theme.palette.common.white,
    },
    actionButton: {
        marginRight: 16,
    },
    actionButtonWrapper: {
        padding: "15px 10px"
    },
    redLabel: {
        color: "red"
    },
    autoComplete: {
        margin: '0.5rem 0 ',
        padding: '0.5rem 0 0.5rem 0.5rem',
        color: theme.palette.common.darkText,
        border: '1px solid lightGrey',
        borderRadius: '4px',

        '&.MuiOutlinedInput-adornedEnd': {
            backgroundColor: theme.palette.background.default,
        },
        '&.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root': {
            padding: '0 !important',
        },
        '&.MuiAutocomplete-inputRoot': {
            padding: '0 !important',
        },
        '&.Mui-disabled': {
            opacity: 0.5,
        },
        '& fieldset': {
            border: 'none'
        }
    },
    itemLabel: {
        fontWeight: 600,
    },
    itemIcon: {
        paddingRight: '1em',
    },
}));